import React, { useContext } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { AiFillEdit } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty } from 'lodash'
import helper from '../../utils/helpers'
import { Link } from 'react-router-dom'

const BlogTable = ({
  blog,
  allBlogs,
  paginationObj,
  sort,
  setSort,
  manager
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeStatusBlog}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allBlogs()
      }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'title' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'title',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'title',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_TITLE')} </span>
                  <span>
                    {sort.sortKey === 'title' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'title' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 cursor-pointer'>
                <div className='flex'>
                  <span>{t('O_TITLE') + t('O_ARABIC')} </span>
                </div>
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'createdAt' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'createdAt',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'createdAt',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_CREATED_AT')} </span>
                  <span>
                    {sort.sortKey === 'createdAt' &&
                      sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sortKey === 'createdAt' &&
                      sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_STATUS')}
                  </th>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_ACTION')}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {blog &&
              blog?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.title}</td>
                  <td className='py-2 px-2 border-r'>{item?.titleAr}</td>
                  <td className='py-2 px-2 border-r'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? 'active' : 'inactive'
                              } ${item.title}?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-4 px-6 border-l'>
                      <div className=''>
                        <ul className='flex justify-center'>
                          <Link
                            title='Edit Blog'
                            className='text-danger ml-2'
                            to='/blogs/Edit-blog'
                            state={{ ...item }}
                          >
                            <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                          </Link>
                        </ul>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(blog) && (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default BlogTable
